import BaseAPI from "./BaseAPI";
import { getAPIUrlV2 } from "../apiConfig";
import { checkFormRoute } from "../routes";
import { newIdempotencyKey } from "@/composables/globalMethods";

export default class CheckFormAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, checkFormRoute, "check-form");
    }

    async Create(data) {
        const result = await this._request("post", this._url(), data);
        this._emit("create", result.id);
        return result;
    }

    async Duplicate(id, data, idempotencyKey = newIdempotencyKey()) {
        const result = await this._request("post", this._url(`/${id}/duplicate`), data, {
            headers: { "Idempotency-Key": idempotencyKey }
        });
        this._emit("create", result.id);
        return result;
    }

    async CreateRevision(id, data, idempotencyKey = newIdempotencyKey()) {
        const result = await this._request("post", this._url(`/${id}/revisions`), data, {
            headers: { "Idempotency-Key": idempotencyKey }
        });
        this._emit("create", result.id);
        return result;
    }

    async Archive(id) {
        const result = await this._request("put", this._url(`/${id}/archive`));
        this._emit("archive", id);
        return result;
    }

    async Unarchive(id) {
        const result = await this._request("delete", this._url(`/${id}/archive`));
        this._emit("unarchive", id);
        return result;
    }

    async MarkArchived(id) {
        const result = await this._request("post", `${getAPIUrlV2("control/check-forms")}/mark-archived?id=${id}`);
        this._emit("mark-archived", id);
        return result;
    }
}
